import dayjs from "dayjs";

export function formatDateTimezoneToUTC(
  datetime: string,
  timezone: string,
  fromFormat: string = "YYYY-MM-DD HH:mm",
  toFormat: string = "DD/MM/YYYY, HH:mm A"
) {
  return dayjs.tz(datetime, fromFormat, timezone).utc().format(toFormat);
}
